import axios from 'axios'
import { getBaseUrl, handleErrors } from '~/api/common'

const filesApi = axios.create({
  baseURL: getBaseUrl() + '/files',
  withCredentials: true,
  validateStatus: () => true
})

export async function uploadFiles ({ files }) {
  const formData = new FormData()
  files.forEach(file => formData.append('files', file))

  const { data: payload } = await filesApi.post('/upload', formData)

  return handleErrors(payload)
}
